/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { OmitFunctions } from 'src/core/stores/types';
import { AuthoringRegion } from 'src/core/types/regionTypes';

type AppToExportStoreData = OmitFunctions<Omit<AppToExportStore, 'id'>>;

export class AppToExportStore {
    public id: string;

    public appId: string;

    public appName: string;

    public ownerEmail: string;

    public hasPredictionResource: boolean;

    public region: AuthoringRegion;

    constructor(id: string, data: AppToExportStoreData) {
        this.id = id;
        this.appId = data.appId;
        this.appName = data.appName;
        this.ownerEmail = data.ownerEmail;
        this.hasPredictionResource = data.hasPredictionResource;
        this.region = data.region;
    }
}
